import request from './services/axios.js'

// 期刊详情相关接口
// 期刊详情查询
export function GetMagDetail(params) {
  return request({
    params,
    url: '/vas/mag/get',
    method: 'get'
  })
}
// 获取期刊统计概览信息
export function GetMagOverView(params) {
  return request({
    params,
    url: '/vas/mag/getMagOverView',
    method: 'get'
  })
}

// 期刊收录数据库
export function GetincludedDatabase(params) {
  return request({
    params,
    url: '/vas/magPortrait/includedDatabase',
    method: 'get'
  })
}

// 期刊rongyu
export function GetjournalHonor(params) {
  return request({
    params,
    url: '/vas/magPortrait/journalHonor',
    method: 'get'
  })
}

// 期刊信息
export function GetMagInfo(params) {
  return request({
    params,
    url: '/vas/mag/info',
    method: 'get'
  })
}
